// import React, { useState, useEffect, useMemo } from "react";
// import { Button, Select, Input, Table } from "antd"; // Import Table from antd
// import { Bar } from 'react-chartjs-2';
// import {
//     Chart as ChartJS,
//     BarElement,
//     CategoryScale,
//     LinearScale,
//     Title,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import DummyData from "../../../utils/Program_Dashboard_JsonData/Chapter&&ProgramData.json";
// import "./ProgramPage.css";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
// import {
//     Typography,
// } from "@mui/material";

// ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

// const { Option } = Select;

// const Programs = ({ programKey }) => {
//     const programKeys = useMemo(() => [
//         "youWaah", "Anjuli", "cancerCruseders", "careerCompass", "matritva",
//         "ecoFiesta", "pitruParv", "pratibhaSpotlight", "bjsSeed",
//         "gurudakshina", "nirvanaNosh", "chillarParty", "sevaSquad", "yatra"
//     ], []);

//     const { sortedUniqueStates, stateProgramCounts, stateDistrictProgramCounts, districtsByState, chapterDataByProgramAndDistrict } = useMemo(() => {
//         const uniqueStatesMap = new Map();
//         const stateProgramCounts = {};
//         const stateDistrictProgramCounts = {};
//         const districtsByStateRaw = {};
//         const chapterDataByProgramAndDistrict = {};

//         if (!Array.isArray(DummyData)) {
//             console.error("DummyData is not an array. Please check the imported JSON data structure.");
//             return {
//                 sortedUniqueStates: [],
//                 stateProgramCounts: {},
//                 stateDistrictProgramCounts: {},
//                 districtsByState: {},
//                 chapterDataByProgramAndDistrict: {}
//             };
//         }

//         DummyData.forEach(item => {
//             const stateShortCode = item.stateShortCode;
//             const bjsState = item.bjsState;
//             const districtName = item.districtName;
//             const chapterName = item.chapterName;

//             if (!uniqueStatesMap.has(stateShortCode)) {
//                 uniqueStatesMap.set(stateShortCode, bjsState);
//             }

//             if (!stateProgramCounts[stateShortCode]) {
//                 stateProgramCounts[stateShortCode] = {};
//                 programKeys.forEach(program => {
//                     stateProgramCounts[stateShortCode][program] = 0;
//                 });
//             }

//             if (!stateDistrictProgramCounts[stateShortCode]) {
//                 stateDistrictProgramCounts[stateShortCode] = {};
//             }
//             if (!stateDistrictProgramCounts[stateShortCode][districtName]) {
//                 stateDistrictProgramCounts[stateShortCode][districtName] = {};
//                 programKeys.forEach(program => {
//                     stateDistrictProgramCounts[stateShortCode][districtName][program] = 0;
//                 });
//             }

//             if (!districtsByStateRaw[stateShortCode]) {
//                 districtsByStateRaw[stateShortCode] = new Map();
//             }
//             if (!districtsByStateRaw[stateShortCode].has(districtName)) {
//                 districtsByStateRaw[stateShortCode].set(districtName, 0);
//             }

//             if (!chapterDataByProgramAndDistrict[stateShortCode]) chapterDataByProgramAndDistrict[stateShortCode] = {};
//             if (!chapterDataByProgramAndDistrict[stateShortCode][districtName]) chapterDataByProgramAndDistrict[stateShortCode][districtName] = {};

//             programKeys.forEach(program => {
//                 if (item[program] === "Yes") {
//                     stateProgramCounts[stateShortCode][program]++;
//                     stateDistrictProgramCounts[stateShortCode][districtName][program]++;
//                     districtsByStateRaw[stateShortCode].set(
//                         districtName,
//                         districtsByStateRaw[stateShortCode].get(districtName) + 1
//                     );
//                     if (!chapterDataByProgramAndDistrict[stateShortCode][districtName][program]) {
//                         chapterDataByProgramAndDistrict[stateShortCode][districtName][program] = [];
//                     }
//                     chapterDataByProgramAndDistrict[stateShortCode][districtName][program].push(chapterName);
//                 }
//             });
//         });

//         const sortedStates = Array.from(uniqueStatesMap.entries())
//             .map(([shortCode, fullName]) => ({ shortCode, fullName }))
//             .sort((a, b) => a.fullName.localeCompare(b.fullName));

//         const districtsByState = {};
//         for (const stateCode in districtsByStateRaw) {
//             districtsByState[stateCode] = Array.from(districtsByStateRaw[stateCode].entries())
//                 .map(([name, totalPrograms]) => ({ name, totalPrograms }))
//                 .sort((a, b) => a.name.localeCompare(b.name));
//         }

//         return {
//             sortedUniqueStates: sortedStates,
//             stateProgramCounts,
//             stateDistrictProgramCounts,
//             districtsByState,
//             chapterDataByProgramAndDistrict
//         };
//     }, [programKeys]);

//     const [selectedProgram, setSelectedProgram] = useState(programKey);
//     const [selectedStateForDistrictView, setSelectedStateForDistrictView] = useState(null);
//     const [selectedDistrict, setSelectedDistrict] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [sortOrder, setSortOrder] = useState('asc');
//     const [filterCategory, setFilterCategory] = useState('');
//     const [selectedState, setSelectedState] = useState(null);

//     useEffect(() => {
//         setSelectedProgram(programKey);
//         setLoading(true);
//     }, [programKey]);

//     useEffect(() => {
//         const timer = setTimeout(() => {
//             setLoading(false);
//         }, 500);
//         return () => clearTimeout(timer);
//     }, [selectedProgram, selectedStateForDistrictView, selectedDistrict, selectedState, searchTerm, filterCategory]);

//     const handleProgramTabChange = (key) => {
//         setLoading(true);
//         setSelectedProgram(key);
//     };

//     const handleStateDropdownChange = (value) => {
//         setLoading(true);
//         setSelectedStateForDistrictView(value);
//         setSelectedDistrict(null);
//     };

//     const handleDistrictDropdownChange = (value) => {
//         setLoading(true);
//         setSelectedDistrict(value);
//     };

//     const handleViewTotals = () => {
//         setLoading(true);
//         setSelectedProgram('all');
//         setSelectedStateForDistrictView(null);
//         setSelectedDistrict(null);
//         setSelectedState(null); // Clear state and district for the table too
//         setSearchTerm('');
//         setFilterCategory('');
//     };

//     const handleSearchChange = (e) => setSearchTerm(e.target.value);
//     const handleSortChange = (value) => setSortOrder(value);
//     const handleFilterCategoryChange = (value) => setFilterCategory(value);
//     const handleStateChange = (value) => {
//         setSelectedState(value);
//         setSelectedDistrict(null);
//     };
//     const handleDistrictChange = (value) => setSelectedDistrict(value);

//     const formatProgramName = (key) => key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());

//     const { chartData, chartOptions } = useMemo(() => {
//         let labels = [];
//         let datasets = [];
//         let chartTitle = '';
//         let isStacked = false;
//         let xAxisTitle = '';
//         let yAxisTitle = 'Number of Chapters';

//         if (selectedStateForDistrictView && selectedDistrict && selectedProgram !== 'all') {
//             const chapters = chapterDataByProgramAndDistrict[selectedStateForDistrictView]?.[selectedDistrict]?.[selectedProgram] || [];
//             labels = chapters;
//             const selectedStateFullName = sortedUniqueStates.find(s => s.shortCode === selectedStateForDistrictView)?.fullName || selectedStateForDistrictView;
//             chartTitle = `${formatProgramName(selectedProgram)} Chapters in ${selectedDistrict}, ${selectedStateFullName}`;
//             xAxisTitle = 'Chapter Name';
//             yAxisTitle = 'Count';

//             datasets = [{
//                 label: `Chapters`,
//                 data: chapters.map(() => 1),
//                 backgroundColor: '#36a2eb',
//                 borderColor: '#36a2eb',
//                 borderWidth: 1,
//             }];
//         } else if (selectedStateForDistrictView && (selectedDistrict === 'all' || !selectedDistrict)) {
//             const districts = districtsByState[selectedStateForDistrictView] || [];
//             labels = districts.map(d => d.name);
//             const selectedStateFullName = sortedUniqueStates.find(s => s.shortCode === selectedStateForDistrictView)?.fullName || selectedStateForDistrictView;
//             xAxisTitle = 'Districts';

//             if (selectedProgram === 'all') {
//                 chartTitle = `District-wise Program participation in ${selectedStateFullName}`;
//                 isStacked = true;
//                 datasets = programKeys.map((programKey, index) => {
//                     const dataForProgram = labels.map(districtName =>
//                         stateDistrictProgramCounts[selectedStateForDistrictView]?.[districtName]?.[programKey] || 0
//                     );
//                     return {
//                         label: formatProgramName(programKey),
//                         data: dataForProgram,
//                         backgroundColor: `hsla(${(index * 137.508) % 360}, 70%, 60%, 0.8)`,
//                         borderColor: `hsla(${(index * 137.508) % 360}, 70%, 60%, 1)`,
//                         borderWidth: 1,
//                         stack: 'programs',
//                     };
//                 });
//             } else {
//                 chartTitle = `${formatProgramName(selectedProgram)} Participation by District in ${selectedStateFullName}`;
//                 const dataForProgram = labels.map(districtName =>
//                     stateDistrictProgramCounts[selectedStateForDistrictView]?.[districtName]?.[selectedProgram] || 0
//                 );
//                 datasets = [{
//                     label: `Count for ${formatProgramName(selectedProgram)}`,
//                     data: dataForProgram,
//                     backgroundColor: '#36a2eb',
//                     borderColor: '#36a2eb',
//                     borderWidth: 1,
//                 }];
//             }
//         } else if (selectedStateForDistrictView && selectedDistrict) {
//             labels = programKeys.map(formatProgramName);
//             const selectedStateFullName = sortedUniqueStates.find(s => s.shortCode === selectedStateForDistrictView)?.fullName || selectedStateForDistrictView;
//             chartTitle = `Program Participation in ${selectedDistrict}, ${selectedStateFullName}`;
//             xAxisTitle = 'Programs';

//             const programCountsInDistrict = stateDistrictProgramCounts[selectedStateForDistrictView]?.[selectedDistrict] || {};
//             const dataForPrograms = programKeys.map(programKey => programCountsInDistrict[programKey] || 0);

//             datasets = [{
//                 label: 'Number of Chapters',
//                 data: dataForPrograms,
//                 backgroundColor: programKeys.map((_, index) => `hsla(${(index * 137.508) % 360}, 70%, 60%, 0.8)`),
//                 borderColor: programKeys.map((_, index) => `hsla(${(index * 137.508) % 360}, 70%, 60%, 1)`),
//                 borderWidth: 1,
//             }];
//         } else {
//             labels = sortedUniqueStates.map(s => s.shortCode);
//             xAxisTitle = 'States';

//             if (selectedProgram === 'all') {
//                 chartTitle = 'Overall Program Participation by State';
//                 isStacked = true;
//                 datasets = programKeys.map((programKey, index) => {
//                     const dataForProgram = labels.map((_, i) =>
//                         stateProgramCounts[sortedUniqueStates[i].shortCode]?.[programKey] || 0
//                     );
//                     return {
//                         label: formatProgramName(programKey),
//                         data: dataForProgram,
//                         backgroundColor: `hsla(${(index * 137.508) % 360}, 70%, 60%, 0.8)`,
//                         borderColor: `hsla(${(index * 137.508) % 360}, 70%, 60%, 1)`,
//                         borderWidth: 1,
//                         stack: 'programs',
//                     };
//                 });
//             } else {
//                 chartTitle = `${formatProgramName(selectedProgram)} Participation by State`;
//                 const dataForProgram = sortedUniqueStates.map(state =>
//                     stateProgramCounts[state.shortCode]?.[selectedProgram] || 0
//                 );
//                 datasets = [{
//                     label: `Count for ${formatProgramName(selectedProgram)}`,
//                     data: dataForProgram,
//                     backgroundColor: '#36a2eb',
//                     borderColor: '#36a2eb',
//                     borderWidth: 1,
//                 }];
//             }
//         }

//         const options = {
//             responsive: true,
//             maintainAspectRatio: false,
//             plugins: {
//                 legend: {
//                     position: 'top',
//                     labels: {
//                         font: { size: 14, },
//                     },
//                 },
//                 title: {
//                     display: true,
//                     text: chartTitle,
//                     font: { size: 18, weight: 'bold', },
//                 },
//                 tooltip: {
//                     mode: 'index',
//                     intersect: false,
//                 },
//             },
//             scales: {
//                 x: {
//                     type: 'category',
//                     // stacked: isStacked,
//                     title: {
//                         display: true,
//                         text: xAxisTitle,
//                         font: {
//                             size: 16,
//                             weight: 'bold',
//                         },
//                     },
//                     ticks: {
//                         autoSkip: false,
//                         maxRotation: 45,
//                         minRotation: 45,
//                         font: {
//                             size: 12,
//                         },
//                     },
//                     barPercentage: 0.8,
//                     categoryPercentage: 0.8,
//                 },
//                 y: {
//                     stacked: isStacked,
//                     beginAtZero: true,
//                     min: 0,
//                     title: {
//                         display: true,
//                         text: yAxisTitle,
//                         font: {
//                             size: 16,
//                             weight: 'bold',
//                         },
//                     },
//                     ticks: {
//                         stepSize: 1,
//                         font: {
//                             size: 12,
//                         },
//                     },
//                 },
//             },
//         };

//         return { chartData: { labels, datasets }, chartOptions: options };
//     }, [selectedProgram, selectedStateForDistrictView, selectedDistrict, stateProgramCounts, stateDistrictProgramCounts, programKeys, sortedUniqueStates, districtsByState, chapterDataByProgramAndDistrict]);

//     // FIX: This useMemo is the key to correct filtering.
//     const filteredChaptersForTable = useMemo(() => {
//         let filtered = DummyData;

//         // Condition 1: Filter by Program if selected
//         if (selectedProgram !== 'all') {
//             filtered = filtered.filter(item => item[selectedProgram] === 'Yes');
//         }

//         // Condition 2: Filter by State if selected
//         if (selectedState) {
//             filtered = filtered.filter(item => item.stateShortCode === selectedState);
//         }

//         // Condition 3: Filter by District if selected
//         if (selectedDistrict) {
//             filtered = filtered.filter(item => item.districtName === selectedDistrict);
//         }

//         // Condition 4: Filter by search term
//         if (searchTerm) {
//             filtered = filtered.filter(item =>
//                 item.chapterName.toLowerCase().includes(searchTerm.toLowerCase())
//             );
//         }

//         // Condition 5: Filter by category
//         if (filterCategory) {
//             filtered = filtered.filter(item => item.category === filterCategory);
//         }

//         return filtered.map(chapter => ({
//             ...chapter,
//             key: chapter._id.$oid,
//             programsConducted: programKeys
//                 .filter(key => chapter[key] === 'Yes')
//                 .map(formatProgramName)
//                 .join(', ') || 'None'
//         }));
//     }, [DummyData, selectedProgram, selectedState, selectedDistrict, searchTerm, filterCategory, programKeys]);

//     const Columns = useMemo(() => [
//         {
//             title: "Chapter Name",
//             dataIndex: "chapterName",
//             key: "chapterName",
//             width: '250px',
//             sorter: (a, b) => a.chapterName.localeCompare(b.chapterName),
//         },
//         {
//             title: "State Name",
//             dataIndex: "bjsState",
//             key: "bjsState",
//             width: '100px',
//             sorter: (a, b) => a.bjsState.localeCompare(b.bjsState),
//         },
//         {
//             title: "District Name",
//             dataIndex: "districtName",
//             key: "districtName",
//             width: '100px',
//             sorter: (a, b) => a.districtName.localeCompare(b.districtName),
//         },
//         {
//             title: "Programs Conducted",
//             dataIndex: "programsConducted",
//             key: "programsConducted",
//             width: '450px',
//             overflowX: 'scroll'
//         },
//     ], []);

//     return (
//         <div className="p-4 text-center">
//             <div className="flex items-center gap-4">
//                 {selectedStateForDistrictView && (<Button
//                     onClick={handleViewTotals}
//                     className="px-6 py-2 rounded-md shadow-md transition duration-300 ease-in-out"
//                     type={(selectedProgram === 'all' && !selectedStateForDistrictView && !selectedDistrict) ? 'primary' : 'default'}
//                     style={{
//                         backgroundColor: (selectedProgram === 'all' && !selectedStateForDistrictView && !selectedDistrict) ? '#1890ff' : '#f0f2f5',
//                         color: (selectedProgram === 'all' && !selectedStateForDistrictView && !selectedDistrict) ? '#fff' : 'rgba(0, 0, 0, 0.85)',
//                         borderColor: (selectedProgram === 'all' && !selectedStateForDistrictView && !selectedDistrict) ? '#1890ff' : '#d9d9d9',
//                         fontWeight: (selectedProgram === 'all' && !selectedStateForDistrictView && !selectedDistrict) ? 'bold' : 'normal',
//                     }}
//                 >
//                     Clear Filters
//                 </Button>
//                 )}

//                 <Select
//                     showSearch
//                     placeholder="Select State"
//                     defaultValue={"all"}
//                     optionFilterProp="children"
//                     onChange={handleStateDropdownChange}
//                     value={selectedStateForDistrictView}
//                     allowClear
//                     style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
//                     filterOption={(input, option) =>
//                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                     }
//                 >
//                     <Option key="all" value={null}>
//                         All States
//                     </Option>
//                     {sortedUniqueStates.map((state) => (
//                         <Option key={state.shortCode} value={state.shortCode}>
//                             {state.fullName}
//                         </Option>
//                     ))}
//                 </Select>

//                 <Select
//                     showSearch
//                     placeholder="Select District"
//                     defaultValue={"all"}
//                     optionFilterProp="children"
//                     onChange={handleDistrictDropdownChange}
//                     value={selectedDistrict}
//                     allowClear
//                     style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
//                 >
//                     <Option key="all" value={null}>
//                         All Districts
//                     </Option>
//                     {(districtsByState[selectedStateForDistrictView] || []).map((district) => (
//                         <Option key={district.name} value={district.name}>
//                             {district.name} ({district.totalPrograms})
//                         </Option>
//                     ))}
//                 </Select>

//                 <Select
//                     showSearch
//                     placeholder="Select a Program"
//                     optionFilterProp="children"
//                     defaultValue={"all"}
//                     onChange={handleProgramTabChange}
//                     value={selectedProgram === 'all' ? null : selectedProgram}
//                     style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
//                     filterOption={(input, option) =>
//                         option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                     }
//                 >
//                     <Option key="all" value="all">
//                         All Programs
//                     </Option>
//                     {programKeys.map((program) => (
//                         <Option key={program} value={program}>
//                             {formatProgramName(program)}
//                         </Option>
//                     ))}
//                 </Select>
//             </div>

//             <div className="d-flex flex-column gap-10 justify-between">
//                 <div className="mt-5 p-4 bg-red rounded-lg shadow-lg" style={{ height: "90vh" }}>
//                     {loading ? (
//                         <p className="text-center text-gray-500 text-lg">Loading chart data...</p>
//                     ) : chartData.labels && chartData.labels.length > 0 ? (
//                         <Bar data={chartData} options={chartOptions} />
//                     ) : (
//                         <p className="text-center text-gray-500 text-lg">
//                             {selectedStateForDistrictView && !selectedDistrict
//                                 ? `${<ExclamationCircleOutlined />} No program data available for districts in the selected state.`
//                                 : selectedStateForDistrictView && selectedDistrict
//                                     ? `No program data available for ${selectedDistrict}, ${sortedUniqueStates.find(s => s.shortCode === selectedStateForDistrictView)?.fullName || selectedStateForDistrictView}.`
//                                     : "Select a program tab or use the dropdowns to view data."}
//                         </p>
//                     )}
//                 </div>

//                 <div className="mt-5 p-4 bg-white rounded-lg shadow-lg">
//                     <h3 className="text-xl font-bold text-center mb-4">Chapter Details</h3>

//                     <div className="flex flex-wrap items-center justify-start mb-4 gap-4">
//                         <Input.Search
//                             placeholder="Search by Chapter Name"
//                             value={searchTerm}
//                             onChange={handleSearchChange}
//                             style={{ width: 250 }}
//                             className="filter-item"
//                         />

//                         {/*  T E M P O R A R I L Y   H I D D E N... */}
//                         <Select
//                             placeholder="Filter by Category"
//                             value={filterCategory}
//                             onChange={handleFilterCategoryChange}
//                             style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
//                             className="filter-item"
//                         >
//                             <Option value="">All</Option>
//                             <Option value="Aspirational">Aspirational</Option>
//                             <Option value="Vibrant">Vibrant</Option>
//                         </Select>
//                         <Select
//                             showSearch
//                             placeholder="Select State"
//                             optionFilterProp="children"
//                             onChange={handleStateChange}
//                             value={selectedState}
//                             allowClear
//                             style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
//                             filterOption={(input, option) =>
//                                 option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                             }
//                             className="filter-item"
//                         >
//                             <Option value="">All States</Option>
//                             {sortedUniqueStates.map((state) => (
//                                 <Option key={state.shortCode} value={state.shortCode}>
//                                     {state.fullName}
//                                 </Option>
//                             ))}
//                         </Select>
//                         <Select
//                             showSearch
//                             placeholder="Select District"
//                             optionFilterProp="children"
//                             onChange={handleDistrictChange}
//                             value={selectedDistrict}
//                             allowClear
//                             style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
//                             disabled={!selectedState}
//                             filterOption={(input, option) =>
//                                 option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                             }
//                             className="filter-item"
//                         >
//                             <Option value="">All Districts</Option>
//                             {(districtsByState[selectedState] || []).map((district) => (
//                                 <Option key={district.name} value={district.name}>
//                                     {district.name}
//                                 </Option>
//                             ))}
//                         </Select>
//                         {/*  T E M P O R A R I L Y   H I D D E N... */}

//                     </div>
//                     {loading ? (
//                         <p className="text-center text-gray-500 text-lg">Loading chapter list...</p>
//                     ) : (
//                         <div style={{ width: '85vw', overflowX: 'scroll' }}>
//                             <Table
//                                 columns={Columns}
//                                 className="ChapterTable"
//                                 dataSource={filteredChaptersForTable}
//                                 pagination={{ pageSize: 10 }}
//                                 scroll={{ y: 400, x: 'max-content' }}
//                                 rowKey={record => record._id.$oid}
//                             />
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div >
//     );
// };

// export default Programs;

import React, { useState, useEffect, useMemo } from "react";
import { Button, Select, Input, Table } from "antd";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import DummyData from "../../../utils/Program_Dashboard_JsonData/Chapter&&ProgramData.json";
import "./ProgramPage.css";
import { ExclamationCircleOutlined } from "@ant-design/icons";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const { Option } = Select;

const Programs = ({ programData }) => {
  const [selectedCategoryKey, setSelectedCategoryKey] =
    useState("foundational");
  const [selectedProgram, setSelectedProgram] = useState("all");

  // Get the list of programs for ONLY the currently selected category
  const programsForSelectedCategory = useMemo(() => {
    if (!selectedCategoryKey) return [];
    const category = programData.find((cat) => cat.key === selectedCategoryKey);
    return category ? category.children : [];
  }, [selectedCategoryKey, programData]);

  const colorMap = useMemo(() => {
    const map = {};
    programData.forEach((category) => {
      category.children.forEach((program) => {
        map[program.key] = program.color || "#C9CBCF"; // Use a default grey if color is missing
      });
    });
    return map;
  }, [programData]);

  // ===================================================================
  // ## KEY CHANGE 1: Create the Correct List of Programs for Filtering
  // ===================================================================
  // This is the new "source of truth" for filtering data.
  const programKeysForFilter = useMemo(() => {
    // If a specific program is selected, the list is just that one program.
    if (selectedProgram !== "all") {
      return [selectedProgram];
    }
    // If 'all' is selected, the list contains ALL programs from the CURRENT category.
    return programsForSelectedCategory.map((p) => p.key);
  }, [selectedProgram, programsForSelectedCategory]);
  // ===================================================================

  // This data processing logic can remain the same
  const {
    sortedUniqueStates,
    stateProgramCounts,
    stateDistrictProgramCounts,
    districtsByState,
    chapterDataByProgramAndDistrict,
  } = useMemo(() => {
    const allProgramKeys = programData.flatMap((cat) =>
      cat.children.map((prog) => prog.key)
    );
    const uniqueStatesMap = new Map();
    const stateProgramCounts = {};
    const stateDistrictProgramCounts = {};
    const districtsByStateRaw = {};
    const chapterDataByProgramAndDistrict = {};

    if (!Array.isArray(DummyData))
      return {
        sortedUniqueStates: [],
        stateProgramCounts: {},
        stateDistrictProgramCounts: {},
        districtsByState: {},
        chapterDataByProgramAndDistrict: {},
      };

    DummyData.forEach((item) => {
      const stateShortCode = item.stateShortCode,
        bjsState = item.bjsState,
        districtName = item.districtName,
        chapterName = item.chapterName;
      if (!uniqueStatesMap.has(stateShortCode))
        uniqueStatesMap.set(stateShortCode, bjsState);
      if (!stateProgramCounts[stateShortCode]) {
        stateProgramCounts[stateShortCode] = {};
        allProgramKeys.forEach(
          (p) => (stateProgramCounts[stateShortCode][p] = 0)
        );
      }
      if (!stateDistrictProgramCounts[stateShortCode])
        stateDistrictProgramCounts[stateShortCode] = {};
      if (!stateDistrictProgramCounts[stateShortCode][districtName]) {
        stateDistrictProgramCounts[stateShortCode][districtName] = {};
        allProgramKeys.forEach(
          (p) =>
            (stateDistrictProgramCounts[stateShortCode][districtName][p] = 0)
        );
      }
      if (!districtsByStateRaw[stateShortCode])
        districtsByStateRaw[stateShortCode] = new Map();
      if (!districtsByStateRaw[stateShortCode].has(districtName))
        districtsByStateRaw[stateShortCode].set(districtName, 0);
      if (!chapterDataByProgramAndDistrict[stateShortCode])
        chapterDataByProgramAndDistrict[stateShortCode] = {};
      if (!chapterDataByProgramAndDistrict[stateShortCode][districtName])
        chapterDataByProgramAndDistrict[stateShortCode][districtName] = {};

      allProgramKeys.forEach((program) => {
        if (item[program] === "Yes") {
          stateProgramCounts[stateShortCode][program]++;
          stateDistrictProgramCounts[stateShortCode][districtName][program]++;
          districtsByStateRaw[stateShortCode].set(
            districtName,
            districtsByStateRaw[stateShortCode].get(districtName) + 1
          );
          if (
            !chapterDataByProgramAndDistrict[stateShortCode][districtName][
              program
            ]
          )
            chapterDataByProgramAndDistrict[stateShortCode][districtName][
              program
            ] = [];
          chapterDataByProgramAndDistrict[stateShortCode][districtName][
            program
          ].push(chapterName);
        }
      });
    });

    const sortedStates = Array.from(uniqueStatesMap.entries())
      .map(([sc, fn]) => ({ shortCode: sc, fullName: fn }))
      .sort((a, b) => a.fullName.localeCompare(b.fullName));
    const districtsByState = {};
    for (const stateCode in districtsByStateRaw)
      districtsByState[stateCode] = Array.from(
        districtsByStateRaw[stateCode].entries()
      )
        .map(([n, t]) => ({ name: n, totalPrograms: t }))
        .sort((a, b) => a.name.localeCompare(b.name));

    return {
      sortedUniqueStates: sortedStates,
      stateProgramCounts,
      stateDistrictProgramCounts,
      districtsByState,
      chapterDataByProgramAndDistrict,
    };
  }, [programData]);

  const [selectedStateForDistrictView, setSelectedStateForDistrictView] =
    useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("");
  const [selectedState, setSelectedState] = useState(null);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [
    selectedProgram,
    selectedCategoryKey,
    selectedStateForDistrictView,
    selectedDistrict,
    selectedState,
    searchTerm,
    filterCategory,
  ]);

  const handleProgramTabChange = (key) => {
    setLoading(true);
    setSelectedProgram(key);
  };

  const handleCategoryChange = (key) => {
    setSelectedCategoryKey(key);
    setSelectedProgram("all");
  };

  const handleStateDropdownChange = (value) => {
    setLoading(true);
    setSelectedStateForDistrictView(value);
    setSelectedDistrict(null);
  };

  const handleDistrictDropdownChange = (value) => {
    setLoading(true);
    setSelectedDistrict(value);
  };

  const handleViewTotals = () => {
    setLoading(true);
    setSelectedProgram("all");
    setSelectedCategoryKey("foundational");
    setSelectedStateForDistrictView(null);
    setSelectedDistrict(null);
    setSelectedState(null);
    setSearchTerm("");
    setFilterCategory("");
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);
  const handleFilterCategoryChange = (value) => setFilterCategory(value);
  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedDistrict(null);
  };
  const handleDistrictChange = (value) => setSelectedDistrict(value);

  const formatProgramName = (key) =>
    key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

  const { chartData, chartOptions } = useMemo(() => {
    // ... Chart logic (I've collapsed it for brevity, but it's fully corrected below)
    let labels = [];
    let datasets = [];
    let chartTitle = "";
    let isStacked = false;
    let xAxisTitle = "";
    let yAxisTitle = "Number of Chapters";

    // Single program in a district view
    if (
      selectedStateForDistrictView &&
      selectedDistrict &&
      selectedProgram !== "all"
    ) {
      const chapters =
        chapterDataByProgramAndDistrict[selectedStateForDistrictView]?.[
          selectedDistrict
        ]?.[selectedProgram] || [];
      labels = chapters;
      const selectedStateFullName =
        sortedUniqueStates.find(
          (s) => s.shortCode === selectedStateForDistrictView
        )?.fullName || selectedStateForDistrictView;
      chartTitle = `${formatProgramName(
        selectedProgram
      )} Chapters in ${selectedDistrict}, ${selectedStateFullName}`;
      xAxisTitle = "Chapter Name";
      datasets = [
        {
          label: `Chapters`,
          data: chapters.map(() => 1),
          backgroundColor: "#36a2eb",
        },
      ];
    }
    // District-level view
    else if (selectedStateForDistrictView) {
      const districts = districtsByState[selectedStateForDistrictView] || [];
      labels = districts.map((d) => d.name);
      const selectedStateFullName =
        sortedUniqueStates.find(
          (s) => s.shortCode === selectedStateForDistrictView
        )?.fullName || selectedStateForDistrictView;
      xAxisTitle = "Districts";
      chartTitle = `District-wise participation in ${selectedStateFullName}`;
      isStacked = true;

      // ===================================================================
      // ## KEY CHANGE 2: Chart logic now uses `programKeysForFilter`
      // ===================================================================
      datasets = programKeysForFilter.map((programKey, index) => {
        const dataForProgram = labels.map(
          (districtName) =>
            stateDistrictProgramCounts[selectedStateForDistrictView]?.[
              districtName
            ]?.[programKey] || 0
        );
        return {
          label: formatProgramName(programKey),
          data: dataForProgram,
          backgroundColor: colorMap[programKey],
          stack: "programs",
        };
      });
      // ===================================================================
    }
    // State-level view (default)
    else {
      labels = sortedUniqueStates.map((s) => s.shortCode);
      xAxisTitle = "States";
      chartTitle = "Overall Program Participation by State";
      isStacked = true;

      // Also use `programKeysForFilter` here
      datasets = programKeysForFilter.map((programKey, index) => {
        const dataForProgram = labels.map(
          (_, i) =>
            stateProgramCounts[sortedUniqueStates[i].shortCode]?.[programKey] ||
            0
        );
        return {
          label: formatProgramName(programKey),
          data: dataForProgram,
          backgroundColor: `hsla(${(index * 137.508) % 360}, 70%, 60%, 0.8)`,
          stack: "programs",
        };
      });
    }

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { position: "top" },
        title: {
          display: true,
          text: chartTitle,
          font: { size: 18, weight: "bold" },
        },
        tooltip: {
          mode: "index",
          intersect: false,
        },
      },
      scales: {
        x: {
          stacked: isStacked,
          title: {
            display: true,
            text: xAxisTitle,
            font: { size: 16, weight: "bold" },
          },
          ticks: { autoSkip: false, maxRotation: 45, minRotation: 45 },
        },
        y: {
          stacked: isStacked,
          beginAtZero: true,
          title: {
            display: true,
            text: yAxisTitle,
            font: { size: 16, weight: "bold" },
          },
          ticks: { stepSize: 1 },
        },
      },
    };

    return { chartData: { labels, datasets }, chartOptions: options };
  }, [
    programKeysForFilter,
    selectedStateForDistrictView,
    selectedDistrict,
    stateProgramCounts,
    stateDistrictProgramCounts,
    sortedUniqueStates,
    districtsByState,
    chapterDataByProgramAndDistrict,
  ]);

  const filteredChaptersForTable = useMemo(() => {
    return DummyData.filter((item) => {
      // ===================================================================
      // ## KEY CHANGE 3: Table logic now uses `programKeysForFilter` correctly
      // ===================================================================
      // Chapter must have conducted at least ONE of the programs in our filter list
      const hasProgram = programKeysForFilter.some(
        (key) => item[key] === "Yes"
      );
      if (!hasProgram) return false;
      // ===================================================================

      if (selectedState && item.stateShortCode !== selectedState) return false;
      if (selectedDistrict && item.districtName !== selectedDistrict)
        return false;
      if (
        searchTerm &&
        !item.chapterName.toLowerCase().includes(searchTerm.toLowerCase())
      )
        return false;
      if (filterCategory && item.category !== filterCategory) return false;

      return true;
    }).map((chapter) => ({
      ...chapter,
      key: chapter._id.$oid,
      programsConducted:
        programData
          .flatMap((c) => c.children.map((p) => p.key))
          .filter((key) => chapter[key] === "Yes")
          .map(formatProgramName)
          .join(", ") || "None",
    }));
  }, [
    programKeysForFilter,
    selectedState,
    selectedDistrict,
    searchTerm,
    filterCategory,
    programData,
  ]);

  const Columns = useMemo(
    () => [
      {
        title: "Chapter Name",
        dataIndex: "chapterName",
        key: "chapterName",
        width: 250,
        sorter: (a, b) => a.chapterName.localeCompare(b.chapterName),
      },
      {
        title: "State Name",
        dataIndex: "bjsState",
        key: "bjsState",
        width: 100,
        sorter: (a, b) => a.bjsState.localeCompare(b.bjsState),
      },
      {
        title: "District Name",
        dataIndex: "districtName",
        key: "districtName",
        width: 100,
        sorter: (a, b) => a.districtName.localeCompare(b.districtName),
      },
      {
        title: "Programs Conducted",
        dataIndex: "programsConducted",
        key: "programsConducted",
        width: 450,
      },
    ],
    []
  );

  return (
    <div className="p-4 text-center">
      {/* The dropdown JSX does not need to change */}
      <div className="flex items-center gap-4">
        {selectedStateForDistrictView && (
          <Button onClick={handleViewTotals}>Clear Filters</Button>
        )}
        <Select
          showSearch
          placeholder="Select State"
          optionFilterProp="children"
          onChange={handleStateDropdownChange}
          value={selectedStateForDistrictView}
          allowClear
          style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
        >
          <Option key="all" value={null}>
            All States
          </Option>
          {sortedUniqueStates.map((state) => (
            <Option key={state.shortCode} value={state.shortCode}>
              {state.fullName}
            </Option>
          ))}
        </Select>
        <Select
          showSearch
          placeholder="Select District"
          optionFilterProp="children"
          onChange={handleDistrictDropdownChange}
          value={selectedDistrict}
          allowClear
          style={{ width: 180, border: "1px solid gray", borderRadius: "5px" }}
        >
          <Option key="all" value={null}>
            All Districts
          </Option>
          {(districtsByState[selectedStateForDistrictView] || []).map((d) => (
            <Option key={d.name} value={d.name}>
              {d.name} ({d.totalPrograms})
            </Option>
          ))}
        </Select>
        <Select
          showSearch
          placeholder="Select a Category"
          optionFilterProp="children"
          onChange={handleCategoryChange}
          value={selectedCategoryKey}
          style={{ width: 220, border: "1px solid gray", borderRadius: "5px" }}
        >
          {programData.map((c) => (
            <Option key={c.key} value={c.key}>
              {c.title}
            </Option>
          ))}
        </Select>
        <Select
          showSearch
          placeholder="Select a Program"
          optionFilterProp="children"
          onChange={handleProgramTabChange}
          value={selectedProgram}
          style={{ width: 220, border: "1px solid gray", borderRadius: "5px" }}
          disabled={!selectedCategoryKey}
        >
          <Option key="all" value="all">
            All Programs (in category)
          </Option>
          {programsForSelectedCategory.map((p) => (
            <Option key={p.key} value={p.key}>
              {p.title}
            </Option>
          ))}
        </Select>
      </div>

      {/* The rest of the component for rendering chart and table */}
      <div className="d-flex flex-column gap-10 justify-between mt-5">
        <div
          className="p-4 bg-white rounded-lg shadow-lg"
          style={{ height: "90vh" }}
        >
          {loading ? (
            <p>Loading chart...</p>
          ) : chartData.labels && chartData.labels.length > 0 ? (
            <Bar data={chartData} options={chartOptions} />
          ) : (
            <p>No data to display.</p>
          )}
        </div>
        <div className="mt-5 p-4 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-bold text-center mb-4">
            Chapter Details
          </h3>
          <div className="flex flex-wrap items-center justify-start mb-4 gap-4">
            <Input.Search
              placeholder="Search by Chapter Name"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: 250 }}
            />
            <Select
              placeholder="Filter by Category"
              value={filterCategory}
              onChange={handleFilterCategoryChange}
              style={{
                width: 180,
                border: "1px solid gray",
                borderRadius: "5px",
              }}
            >
              <Option value="">All</Option>
              <Option value="Aspirational">Aspirational</Option>
              <Option value="Vibrant">Vibrant</Option>
            </Select>
            <Select
              showSearch
              placeholder="Select State"
              optionFilterProp="children"
              onChange={handleStateChange}
              value={selectedState}
              allowClear
              style={{
                width: 180,
                border: "1px solid gray",
                borderRadius: "5px",
              }}
            >
              <Option value="">All States</Option>
              {sortedUniqueStates.map((s) => (
                <Option key={s.shortCode} value={s.shortCode}>
                  {s.fullName}
                </Option>
              ))}
            </Select>
            <Select
              showSearch
              placeholder="Select District"
              optionFilterProp="children"
              onChange={handleDistrictChange}
              value={selectedDistrict}
              allowClear
              style={{
                width: 180,
                border: "1px solid gray",
                borderRadius: "5px",
              }}
              disabled={!selectedState}
            >
              <Option value="">All Districts</Option>
              {(districtsByState[selectedState] || []).map((d) => (
                <Option key={d.name} value={d.name}>
                  {d.name}
                </Option>
              ))}
            </Select>
          </div>
          {loading ? (
            <p>Loading list...</p>
          ) : (
            <div style={{ width: "85vw", overflowX: "scroll" }}>
              <Table
                columns={Columns}
                dataSource={filteredChaptersForTable}
                pagination={{ pageSize: 10 }}
                scroll={{ y: 400, x: "max-content" }}
                rowKey="key"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Programs;
